/**
 * @file: QuotationFormStatus.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum QuotationFormStatus {
  Draft = 'draft',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
}

export const QuotationFormStatusValueSet = new Set([
  QuotationFormStatus.Draft,
  QuotationFormStatus.Confirmed,
  QuotationFormStatus.Canceled,
]);
